import router from './router'
import axios from 'axios'
import store from './store'
import VueCookies from 'vue-cookies'

export default {
  logout () {
    //  remove visible cookie
    VueCookies.remove('isAuthed')
    //  set store variables
    store.commit('setIsAuthenticated', false)
    store.commit('setUserRole', null)
    //  remove httpOnly cookie
    axios.post(process.env.ROOT_API + '/logout', {}, {withCredentials: true})
      .then(() => {
        router.push('/login')
      })
      .catch(() => { router.push('/login') })
  },
  successfulLogin (response, push_to = '/') {
    store.commit('setIsAuthenticated', true)
    store.commit('setUserRole', response.data.role)
    store.commit('setUserCapabilities', response.data.capabilities)
    VueCookies.set('isAuthed', response.data.role, '24h')
    VueCookies.set('userCapabilities', response.data.capabilities, '24h')
    router.push(push_to)
  },
  failedLogin () {
    store.commit('setIsAuthenticated', false)
  },
  authenticateWithOAuth (source, code, state) {
    const url = process.env.ROOT_API + '/login?source=' + source
    return new Promise((resolve, reject) => {
      axios.post(url, {'code': code, 'state': state}, {withCredentials: true})
        .then(response => {
          if (response.data.success) {
            this.successfulLogin(response)
          } else {
            this.failedLogin()
          }
          resolve(response)
        })
        .catch(response => {
          this.failedLogin()
          reject(response)
        })
    })
  },
  authenticateWithPassword (username, password) {
    const url = process.env.ROOT_API + '/login'
    return new Promise((resolve, reject) => {
      axios.post(url, {'username': username, 'password': password}, {withCredentials: true})
        .then(response => {
          if (response.data.success) {
            this.successfulLogin(response)
          } else {
            this.failedLogin(response)
          }
          resolve(response)
        })
        .catch(response => {
          this.failedLogin()
          reject(response)
        })
    })
  },
  getLinkedinURL () {
    const getCompanyProfile = false
    if (getCompanyProfile) {
      return 'https://www.linkedin.com/oauth/v2/authorization' +
        '?response_type=code' +
        '&client_id=77b1voggb01owk' +
        '&redirect_uri=' + encodeURIComponent(process.env.ROOT_URL + '/login?source=linkedin') +
        '&state=hdoa0389lzlv9bvJ%23J%2988sjwl' +
        '&scope=rw_organization_admin%20r_organization_social'
    }
    return 'https://www.linkedin.com/oauth/v2/authorization' +
      '?response_type=code' +
      '&client_id=77b1voggb01owk' +
      '&redirect_uri=' + encodeURIComponent(process.env.ROOT_URL + '/login?source=linkedin') +
      '&state=hdoa0389lzlv9bvJ%23J%2988sjwl' +
      '&scope=r_liteprofile'
  },
  getSlackURL () {
    return 'https://slack.com/oauth/authorize' +
      '?scope=identity.basic' +
      '&client_id=135592716369.368914990037' +
      '&redirect_uri=' + encodeURIComponent(process.env.ROOT_URL + '/login?source=slack')
  }
}



// WEBPACK FOOTER //
// ./src/Authentication.js